import React from 'react';
import { executeFunc } from 'lib/helpers';
import { getJEIndexListItemDataAction } from 'domain/journal';

import { List } from 'immutable';

import DialogManageJECellListOption from 'components/Tables/Cells/ListCell/withManageListItemModal/DialogManageJECellListOption';

export default function withManageListItemModal(WrappedComponent) {
  return class Confirmation extends React.Component {
    state = {
      isOpenManageModal: false,
      isLoading: true,
      isEdit: false,
      indexListItemData: new List(),
      initialValues: {},
    };

    onCreate = () => {
      if (this.props.input.isCreatable) {
        return this.handleClick();
      }

      return new Promise(() => '');
    };

    onEdit = (cellValue) => {
      this.setState({ isEdit: true });

      return this.handleClick(cellValue);
    };

    getIndexForm = (field, value) =>
      new Promise((resolve, reject) => {
        const { documentID } = this.props;
        this.props.getIndexForm({
          field,
          value,
          documentID,
          resolve,
          reject,
        });
      });

    handleClick = (cellValue = '') => {
      const { cellName } = this.props.params;
      this.setState({ isLoading: true, indexListItemData: new List() });

      return new Promise((resolve, reject) => {
        this.toggleOpen();
        this.resolve = resolve;
        this.reject = reject;
        this.getIndexForm(cellName, cellValue)
          .then((indexListItemData) => {
            const initialValues = indexListItemData.reduce((acc, item) => {
              acc[item.get('name')] = item.get('value');

              return acc;
            }, {});

            this.setState({ indexListItemData, initialValues });
          })
          .finally(() => this.setState({ isLoading: false }));
      });
    };

    toggleOpen = (status, cb) => {
      this.setState(
        {
          isOpenManageModal: typeof status === 'undefined' ? !this.state.isOpenManageModal : status,
        },
        () => executeFunc(cb),
      );
    };

    cancel = () => {
      this.toggleOpen(false, this.reject);
      this.setState({ isEdit: false, initialValues: {} });
    };

    handleSubmit = (data) => {
      this.toggleOpen(false, () => {
        if (typeof this.resolve === 'function') this.resolve(data);
        this.setState({ initialValues: {} });
      });
    };

    prepareInitialValues = (name) => {
      const { initialValues } = this.state;

      return {
        ...initialValues,
        ...(name && !initialValues.Name ? { Name: name } : {}),
      };
    };

    resolve;

    reject;

    render() {
      const props = {
        ...this.props,
        onEdit: this.onEdit,
        onCreate: this.onCreate,
      };

      const { isOpenManageModal, indexListItemData, isLoading, isEdit } = this.state;

      return (
        <WrappedComponent {...props}>
          {(name, onSearchHandler) =>
            isOpenManageModal && (
              <DialogManageJECellListOption
                cancel={() => this.cancel()}
                indexListItemData={indexListItemData}
                onSubmit={this.handleSubmit}
                initialValues={this.prepareInitialValues(name)}
                isLoading={isLoading}
                isEdit={isEdit}
                onSearchHandler={onSearchHandler}
              />
            )
          }
        </WrappedComponent>
      );
    }
  };
}
